module.exports = __webpack_public_path__ + "static/media/F1.d058763d.webp";